<template>
  <div class="wrapper-sidebar">
    <div class="brand-sidebar text-center">
      <img
        src="../../../assets/logo-white.png"
        alt=""
      />
    </div>
    <ul class="menu-list">
      <li
        v-for="(item, i) in menu"
        :key="i"
        @click="$router.push(item.link ? item.link : null).catch(err => {})"
        :style="styleMenuItem"
        :title="item.title"
      >
        <label :for="`check-${i}`">
          <div>
            <i :class="item.icon"></i>
          </div>
          <div v-if="!collapsed">{{ item.title }}</div>
        </label>
        <input
          type="checkbox"
          :id="`check-${i}`"
          class="check"
          checked
        />
        <ul>

          <li
            v-for="(li, c) in item.children"
            :key="c"
            @click="$router.push(li.link).catch(err => {})"
            class="item-submenu"
          >
            <span><i class="fa fa-chart-area"></i></span>
            <span>{{ li.title }}</span>
          </li>
        </ul>
      </li>

      <li
        :style="styleMenuItem"
        title="Manual de Utilização"
      >
        <div>
          <i class="far fa-file-pdf"></i>
        </div>
        <div v-if="!collapsed">
          <a
            target="_blank"
            href="https://api.bi-assobens.com.br/v1/public/30-09-2022_Manual de utilização BI.pdf"
          >
            Manual de Utilização
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import EventBus from '../../../eventBus';

export default {
  name: 'Sidebar',
  data: () => ({
    userAuth: null,
    collapsed: false,
    styleMenuItem: {},
    menu: [
      /*
      {
        title: 'BI Comercialização',
        icon: 'fa fa-chart-area',
        children: [
          {
            title: 'Veículos Novos Área Operacional',
            link: '/dashboard',
          },
          {
            title: 'Veículos Novos Nacional',
            link: '/emplacamento-nacional',
          },
          {
            title: 'Veículos Usados',
            link: '/veiculos-usados',
          },
          {
            title: 'Estoque Rede',
            link: '/estoque-rede',
          },
        ],
      },
      */
    ],
    dropMenu1: false,
    dropMenu2: false,
    dropMenu3: false,
  }),

  computed: {
    ...mapState('users', ['user']),
  },
  methods: {
    ...mapActions('users', ['getUser']),
  },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
  },
  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
    await this.getUser({ id: this.userAuth.id, token: this.userAuth.token });
    /* Retirar abaixo quando ativar SSO */
    if (!this.userAuth.isSSO) {
      this.userAuth.isPosVendas = true;
      this.userAuth.isVendas = true;
    }
    /* Retirar acima quando ativar SSO */
    this.menu = [];
    if (this.userAuth.isVendas || this.user.type !== 'dealer') {
      this.menu.push(
        {
          title: 'BI Comercialização',
          icon: 'fa fa-chart-area',
          children: [
            {
              title: 'Veículos Novos Área Operacional',
              link: '/dashboard',
            },
            {
              title: 'Veículos Novos Nacional',
              link: '/emplacamento-nacional',
            },
            {
              title: 'Veículos Usados',
              link: '/veiculos-usados',
            },
            {
              title: 'Estoque Rede',
              link: '/estoque-rede',
            },
            {
              title: 'Meu Estoque',
              link: '/meu-estoque',
            },
          ],
        },
      );
      if (this.user.type !== 'dealer') {
        this.menu[0].children.push({
          link: '/relatorio-sfat',
          title: 'Relatório SFATs',
        });
      }
      if (this.user.sfat) {
        this.menu[0].children.push(
          {
            title: 'Veículos Programados com SFAT',
            link: '/estoque-virtual',
          },
        );
      }
      this.menu[0].children.push(
        {
          title: 'Estoque Oferta / Procura',
          link: '/estoque-oferta-procura',
        },
      );
      this.menu[0].children.push(
        {
          title: 'Retiradas Rede',
          link: '/retiradas-rede',
        },
      );
      this.menu[0].children.push(
        {
          title: 'Varejo',
          link: '/varejo',
        },
      );
      this.menu[0].children.push(
        {
          title: 'Frota Circulante',
          link: '/frota-circulante',
        },
      );
      this.menu[0].children.push(
        {
          title: 'Comparativo de Preços',
          link: '/precos-comparativo',
        },
      );
      this.menu[0].children.push(
        {
          title: 'MEF',
          link: '/mef',
        },
      );
    }
    if (this.userAuth.isPosVendas || this.user.type !== 'dealer') {
      this.menu.push(
        {
          title: 'BI Pós Venda',
          icon: 'fa fa-wrench',
          children: [
            {
              title: 'Ações de Campo',
              link: '/acoes-campo',
            },
            {
              title: 'Ativação Conectividade',
              link: '/ativacao-conectividade',
            },
            /*
            {
              title: 'Dashboard S24h',
              link: '/dashboard-s24h',
            },
            */
            {
              title: 'Disponibilidade de Peças',
              link: '/disponibilidade-pecas',
            },
            {
              title: 'Lista de Preços',
              link: '/lista-precos',
            },
            {
              title: 'Marketplace de Peças - Estoque Parado',
              link: '/mkt-pecas',
            },
            {
              title: 'Potencial de Lubrificantes - PSP',
              link: '/potencial-lubrificantes',
            },
            {
              title: 'Potencial de Peças - PSP',
              link: '/potencial-pecas',
            },
            {
              title: 'Potencial de Serviços - PSP',
              link: '/potencial-servicos',
            },
            {
              title: 'Retenção',
              link: '/retencao',
            },
            /*
            {
              title: 'Torre de Controle',
              link: '/torre-controle',
            },
            */
          ],
        },
      );
    }
    // Menu Calculadoras
    this.menu.push(
      {
        title: 'Calculadoras',
        icon: 'fa fa-calculator',
        children: [
          /*
          {
            title: 'DimensionamenTool',
            link: '/dimensionamentool',
          },
          */
          {
            title: 'Troca Rápida',
            link: '/troca-rapida',
          },
        ],
      },
    );
    // Menu Enriquecimento
    if (this.user.enhancement) {
      this.menu.push({
        title: 'Enriquecimento',
        icon: 'fa fa-list',
        children: [
          {
            title: 'Baixar Dados',
            link: '/enriquecimento-baixar-dados',
            // link: '/desenvolvimento',
          },
          {
            title: 'Chassi Específico',
            link: '/chassi-especifico',
            // link: '/desenvolvimento',
          },
        ],
      });
    }
    /*
    this.menu.push({
      title: 'BI Serviços e Peças',
      icon: 'fa fa-list',
      children: [
        {
          title: 'Dashboard - Serviços e Peças',
          link: '/emplacamentos',
        },
      ],
    });
    */
    if (this.user.type !== 'dealer') {
      this.menu.push({
        link: '/users',
        title: 'Usuários',
        icon: 'fa fa-users',
      });
      /*
      this.menu.push({
        title: 'Configurações',
        icon: 'fa fa-cog',
      });
      this.menu.push({
        link: '/analytical-plates',
        title: 'Analítico Emplacamentos',
        icon: 'fas fa-chart-pie',
      });
      */
      this.menu.push({
        link: '/list-logs',
        title: 'Logs de Acesso',
        icon: 'fas fa-bars',
      });
    }
    /*
    this.menu[0].children.push(
      {
        title: 'Meu Estoque',
        link: '/meu-estoque',
      },
    );
    if (this.user.type !== 'dealer') {
      this.menu[0].children.push({
        link: '/relatorio-sfat',
        title: 'Relatório SFATs',
      });
    }
    if (this.user.sfat) {
      this.menu[0].children.push(
        {
          title: 'Veículos Programados com SFAT',
          link: '/estoque-virtual',
        },
      );
    }
    this.menu[0].children.push(
      {
        title: 'Estoque Oferta / Procura',
        link: '/estoque-oferta-procura',
      },
    );
    this.menu[0].children.push(
      {
        title: 'Retiradas Rede',
        link: '/retiradas-rede',
      },
    );
    this.menu[0].children.push(
      {
        title: 'Varejo',
        link: '/varejo',
      },
    );
    this.menu[0].children.push(
      {
        title: 'Frota Circulante',
        link: '/frota-circulante',
      },
    );
    */
    EventBus.$on('collapse', (param) => {
      this.collapsed = param;
      if (param) {
        this.styleMenuItem = {
          'justify-content': 'center',
        };
        const items = document.querySelectorAll('.item-submenu');

        if (items.length > 0) {
          // eslint-disable-next-line no-restricted-syntax
          for (const obj in items) {
            if (items[obj]) items[obj].classList.add('collapsed');
          }
        }
      } else {
        this.styleMenuItem = {};

        const items = document.querySelectorAll('.item-submenu');
        if (items.length > 0) {
          // eslint-disable-next-line no-restricted-syntax
          for (const obj in items) {
            if (items[obj]) items[obj].classList.remove('collapsed');
          }
        }
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.wrapper-sidebar {
  width: 100%;
  max-width: 280px;
  max-height: 100vh;
  min-height: 100vh;
  position: absolute;
  overflow: auto;
  background-color: #303030;
  color: #fff;
  transition: all 0.2s linear;
  .brand-sidebar {
    position: relative;
    margin-top: 10px;
    padding: 5px 8px;
    img {
      width: 100%;
      max-width: 220px;
    }
  }
  .menu-list {
    color: #fff;
    padding-left: 0;
    list-style: none;
    margin-top: 30px;
    width: 100%;
    a {
      color: #fff;
      text-decoration: none;
    }
    > a li,
    > li {
      cursor: pointer;
      width: 100%;
      display: block;
      padding: 5px;
      &:hover {
        background-color: rgba(30, 30, 33, 0.5);
      }
      div {
        cursor: pointer;
        &:first-of-type {
          // background-color: #1e1e21;
          align-items: center;
          justify-content: center;
          width: 30px;
          height: 30px;
          margin: 5px;
          border-radius: 3px;
          display: inline-block;
          text-align: center;
          padding-top: 3px;
        }
        &:last-of-type {
          margin: 5px;
          border-radius: 3px;
          display: inline-block;
        }
      }
      ul {
        overflow: hidden; // Hide the element content, while height = 0
        height: 0;
        opacity: 0;
        transition: height 0ms 400ms, opacity 400ms 0ms;
        list-style: none;
        padding-left: 0;
        li {
          padding: 10px 15px 10px 30px;
          &:hover {
            background-color: rgba(0, 0, 0, 0.2);
          }
          span {
            &:first-of-type {
              display: none;
            }
            &:last-of-type {
              display: block;
            }
          }
        }

        li.collapsed {
          width: 100%;
          padding: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            &:first-of-type {
              display: block;
            }
            &:last-of-type {
              display: none;
            }
          }
          &:hover {
            background-color: rgba(0, 0, 0, 0.2);
          }
        }
      }
      .check {
        display: none;
        &:checked {
          ~ ul {
            height: auto;
            opacity: 1;
            transition: height 0ms 0ms, opacity 600ms 0ms;
          }
        }
      }
    }
  }
}
</style>
